import select2 from 'select2';
import Handsontable from 'handsontable/dist/handsontable.full.min.js';

App.ProductBuilder = (function () {

  function initNew() {
    initSelect2();
  }

  function initEdit() {
    initHot();
    initProductImagePreview();
    initSelect2();
    add_link_prod_section();
    change_link_prod_section();
    initArtAssetPicker();
    initAltSuppliers();

    $("#relationship_select").select2({
      tags: true,
      maximumSelectionLength: 1
    });

    App.Form.pikaday('.pikaday');
  }

  function initArtAssetPicker() {
    var picker = document.getElementById('art-asset-picker');
    if (!picker) return;

    var searchUrl = picker.getAttribute('data-search-url');
    var listUrlTemplate = picker.getAttribute('data-list-url-template');
    var importUrl = picker.getAttribute('data-import-url');
    if (!searchUrl || !listUrlTemplate || !importUrl) return;

    var $select = $('#art-asset-batch-search');
    if (!$select.length) return;

    var token = $('meta[name="csrf-token"]').attr('content');
    if (token) {
      $.ajaxSetup({ headers: { 'X-CSRF-Token': token } });
    }

    $select.select2({
      placeholder: 'Search by batch title or image filename...',
      allowClear: true,
      minimumInputLength: 0,
      ajax: {
        url: searchUrl,
        dataType: 'json',
        delay: 250,
        data: function(params) {
          return { q: params.term || '' };
        },
        processResults: function(data) {
          return {
            results: (data.results || []).map(function(b) {
              var label = b.title + ' \u2013 ' + (b.vendor_name || '') + ' (' + (b.batch_date || '') + ', ' + (b.image_count || 0) + ' images)';
              return { id: b.id, text: label };
            })
          };
        }
      }
    });

    $select.on('select2:select', function(e) {
      var batchId = e.params.data.id;
      loadBatchImages(batchId, listUrlTemplate, importUrl);
    });

    $select.on('select2:clear', function() {
      $('#art-asset-batch-images').empty();
    });

    // Auto-search by item code on page load
    var itemCode = picker.getAttribute('data-item-code');
    if (itemCode) {
      $.ajax({ url: searchUrl, dataType: 'json', data: { q: itemCode } }).done(function(data) {
        var results = data.results || [];
        if (results.length > 0) {
          var first = results[0];
          var label = first.title + ' \u2013 ' + (first.vendor_name || '') + ' (' + (first.batch_date || '') + ', ' + (first.image_count || 0) + ' images)';
          var option = new Option(label, first.id, true, true);
          $select.append(option).trigger('change');
          loadBatchImages(first.id, listUrlTemplate, importUrl);
        }
      });
    }
  }

  function loadBatchImages(batchId, listUrlTemplate, importUrl) {
    var url = listUrlTemplate.replace('BATCH_ID', batchId);
    var $container = $('#art-asset-batch-images');
    $container.html('<em>Loading...</em>');

    $.ajax({ url: url, dataType: 'json' }).done(function(data) {
      var images = (data && data.images) || [];
      $container.empty();
      if (images.length === 0) {
        $container.append('<div style="color:#888; font-style: italic;">No images uploaded for this batch.</div>');
        return;
      }
      images.forEach(function(img) {
        $container.append(buildBatchImageCard(img, importUrl));
      });
    }).fail(function(xhr) {
      $container.html('<div class="callout alert">Failed to load images (status ' + xhr.status + ').</div>');
    });
  }

  function buildBatchImageCard(image, importUrl) {
    var slots = [
      { key: 'master', label: 'Master' },
      { key: 'design_artwork', label: 'Design' },
      { key: 'front_artwork', label: 'Front' },
      { key: 'back_artwork', label: 'Back' },
      { key: 'left_sleeve_art', label: 'Left Sleeve' },
      { key: 'right_sleeve_art', label: 'Right Sleeve' },
      { key: 'extra', label: 'Extra' },
    ];

    var card = $('<div>').addClass('art-asset-batch-image-card').css({
      width: '200px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      padding: '8px',
      background: '#fff'
    });

    card.append(
      '<a href="' + escAttr(image.public_url) + '" target="_blank">' +
        '<img src="' + escAttr(image.thumb_url) + '" style="max-width: 100%; height: auto; display: block;">' +
      '</a>' +
      '<div style="font-size: 11px; word-break: break-all; margin: 4px 0 6px 0;">' + escHtml(image.original_filename || '') + '</div>'
    );

    var slotsWrap = $('<div>').css({ display: 'flex', flexWrap: 'wrap', gap: '4px' });
    slots.forEach(function(slot) {
      var btn = $('<button>')
        .attr('type', 'button')
        .addClass('button tiny secondary js-set-artwork-slot')
        .css({ margin: 0 })
        .text('Set ' + slot.label)
        .data('slot', slot.key)
        .data('image-id', image.id)
        .data('import-url', importUrl);
      slotsWrap.append(btn);
    });
    card.append(slotsWrap);

    return card;
  }

  // Delegated handler so it works for dynamically added cards
  $(document).on('click', '.js-set-artwork-slot', function(e) {
    e.preventDefault();
    var $btn = $(this);
    var importUrl = $btn.data('import-url');
    var slot = $btn.data('slot');
    var imageId = $btn.data('image-id');
    if (!importUrl || !slot || !imageId) return;

    var originalText = $btn.text();
    $btn.prop('disabled', true).text('Setting...');

    $.ajax({
      url: importUrl,
      method: 'POST',
      dataType: 'json',
      data: { image_id: imageId, slot: slot },
    }).done(function(resp) {
      if (resp && resp.success) {
        if (window.App && App.Alert && App.Alert.show) {
          App.Alert.show('Set ' + slot.replace(/_/g, ' '), 'notice');
        }
      } else {
        var msg = (resp && (resp.error || (resp.errors && resp.errors.join(', ')))) || 'Import failed';
        if (window.App && App.Alert && App.Alert.show) {
          App.Alert.show(msg, 'alert');
        } else {
          alert(msg);
        }
      }
    }).fail(function(xhr) {
      var msg = 'Import failed (status ' + xhr.status + ')';
      if (window.App && App.Alert && App.Alert.show) {
        App.Alert.show(msg, 'alert');
      } else {
        alert(msg);
      }
    }).always(function() {
      $btn.prop('disabled', false).text(originalText);
    });
  });

  function escHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function escAttr(s) {
    return escHtml(s).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function initSelect2() {
    $("select").each(function() {
      const $el = $(this);
      const opts = $el.data('select2Tags') ? { tags: true, placeholder: $el.data('placeholder') } : {};
      $el.select2(opts);
    });
  }

  function initPublish() {
    $("select").select2();
  }

  function initProductImagePreview() {
    $('.product-image-preview-links a').on('click', function(e) {
      e.preventDefault();
      var url = $(this).attr("href");
      var html = '<a href="' + url + '" target="_blank"><img src="' + url +  '?w=350&h=350&fit=clip&usm=18"></a>';
      var container = $(this).closest(".product-image-preview");
      container.find(".product-image-preview-image").html(html);
      container.find(".product-image-preview-links a").removeClass('active');
      $(this).addClass('active');
    });

    // select the first one
    $('.product-image-preview-links a:first').click();
  }

  // clone link product section
  function add_link_prod_section() {
    $(".add_prod_relation").on('click', function () {
      var $self = $(this);
      if (($self.prev().find('select')[0].value != '') && ($self.prev().find('.small-5').last().find('input')[0].value != '')) {
        $self.before($self.prev().clone());

        var select_length = $self.prev().find('select').length;
        var previous_relationship = $self.prev().prev();
        var current_relationship = $self.prev();
        current_relationship.find('select')[0].id = "item_link_random";
        current_relationship.find('select')[0].name = "item[link_random][]";
        // previous_relationship.find('input')[0].name = 'link_' + old_value.toLowerCase().split(' ').join('_');
        current_relationship.find('.small-5').last().find('input')[0].name = "link_random_text";
        current_relationship.find('.small-5').last().find('input')[0].id = "link_random_text";
        current_relationship.find('.small-5').last().find('input')[0].value = "";
        current_relationship.find('.small-1').last().find('.center').css("display", "block");

        let new_prd_relation = $('#' + current_relationship.find('select')[0].id + '');
        new_prd_relation.select2({
          tags: true,
          maximumSelectionLength: 1
        });
        // new_prd_relation.find("option:selected").prop("selected", false);
        let prev_prd_relation = $('#' + previous_relationship.find('select')[0].id + '');
        let prev_prd_value = $('#' + previous_relationship.find('select')[0].id + '').val();
        prev_prd_relation.select2();
        prev_prd_relation.select2({
          tags: true,
          maximumSelectionLength: 1
        });
        $('#' + previous_relationship.find('select')[0].id + '').val(prev_prd_value);

        if (new_prd_relation.next().next().find('span').length > 1) {
          new_prd_relation.next().next().remove();
        } else if (new_prd_relation.next().find('span').length > 1) {
          new_prd_relation.next().remove();
        }

        new_prd_relation.val([]);
        new_prd_relation.select2({
          tags: true,
          maximumSelectionLength: 1
        });

        return false;
      } else {
        if ($self.prev().find('select')[0].value == '') {
          alert( 'Please select the last dropdown to proceed');
        } else if ($self.prev().find('.small-5').last().find('input')[0].value == '') {
          alert( 'Please enter the product handle');
        }
        return false;
      }
    });
  }

  // init Handsontable (hot for short)
  function initHot() {
    function hotSizes(query, process) {
      var hot = App.ProductBuilder.hot;
      var allSizes = $("#form_variants").data("sizes");
      var usedSizes = hot.getDataAtCol(0);
      var selectedRange = hot.getSelectedRange()[0];
      var currentSize = hot.getDataAtCell(selectedRange.from.row, selectedRange.from.col)
      process(_.difference(allSizes, _.difference(usedSizes, [currentSize])));
    }

    function afterChange(changes, source) {

      if (changes && source == 'edit') {
        initRowData(changes);
        updateSupplierData(changes);
        updateSitePrices(changes);
      }

      updateHotData();
    }

    // Site price = charm(full_price + weight-tier adder) × 0.7 floor+.99 (matches SubItem.adjusted_price).
    function updateSitePrices(changes) {
      if (!changes || !App.ProductBuilder.hot) return;
      var adders = $("#form_variants").data("price-adders") || [];
      var rows = {};
      $.each(changes, function() {
        var prop = this[1];
        if (prop === "weight" || prop === "full_price" || prop === "price" || prop === "ignore_price_adders") {
          rows[this[0]] = true;
        }
      });
      var updates = [];
      $.each(rows, function(row) {
        row = parseInt(row, 10);
        var site = computeSitePrice(
          App.ProductBuilder.hot.getDataAtRowProp(row, "full_price"),
          App.ProductBuilder.hot.getDataAtRowProp(row, "weight"),
          App.ProductBuilder.hot.getDataAtRowProp(row, "ignore_price_adders"),
          adders
        );
        if (site != null) {
          updates.push([row, "site_price", site]);
        }
      });
      if (updates.length) {
        App.ProductBuilder.hot.setDataAtRowProp(updates, "80s.updateSitePrices");
      }
    }

    function computeSitePrice(fullPrice, weight, ignoreAdders, adders) {
      var full = parseFloat(fullPrice);
      if (!full || full <= 0) return null;
      var pre = full;
      if (!ignoreAdders && adders && adders.length) {
        var oz = (parseFloat(weight) || 0) * 16.0;
        var adder = null;
        for (var i = 0; i < adders.length; i++) {
          if (oz <= adders[i][0]) { adder = adders[i]; break; }
        }
        if (!adder) adder = adders[adders.length - 1];
        if (adder) pre = full + parseFloat(adder[1]);
      }
      var anchor = roundUpLookGood(pre);
      return Math.floor(anchor * 0.7) + 0.99;
    }

    function roundUpLookGood(p) {
      var two = (Math.round(p * 100) / 100).toFixed(2);
      var parts = two.split(".");
      var first = parts[0].slice(-1);
      var larger = parts[0].slice(0, -1);
      var fi = parseInt(first, 10);
      var rounded = first;
      if (fi === 0) {
        rounded = "9";
        var lgi = parseInt(larger || "0", 10);
        if (lgi >= 1) larger = String(lgi - 1);
      } else if (fi >= 3 && fi < 5) {
        rounded = "4";
      } else if (fi > 6) {
        rounded = "9";
      }
      return parseFloat((larger || "") + rounded + ".99");
    }

    function initRowData(changes) {
      $.each(changes, function(index) {
        var row = this;
        var dropshipExclude = App.ProductBuilder.hot.getDataAtCell(row[0], 'dropship_exclude');
        var ignorePriceAdders = App.ProductBuilder.hot.getDataAtCell(row[0], 'ignore_price_adders');
        console.log(ignorePriceAdders);
        if ( dropshipExclude == null ) {
          App.ProductBuilder.hot.setDataAtRowProp(row[0], 'dropship_exclude', false, '80s.initRowData');
        }
        if( ignorePriceAdders == null ) {
          App.ProductBuilder.hot.setDataAtRowProp(row[0], 'ignore_price_adders', false, '80s.initRowData');
        }
      });
    }

    function updateSupplierData(changes) {
      var sizeMap = $("#form_variants").data("size-map");
      var supplierSkuPrefix = $("#form_variants").data("supplier-sku-prefix");
      var supplierDescriptionPrefix = $("#form_variants").data("supplier-description-prefix");

      $.each(changes, function(index) {
        var row = this;
        if (row[1] != 'size') { return true; } // only adjust if size changed
        if (row[2] == row[3]) { return true; } // value didn't actually change

        var size = row[3];
        var supplierSize = sizeMap[size];
        if (size == null || supplierSize == null) { return true; }

        if (supplierSkuPrefix) {
          App.ProductBuilder.hot.setDataAtRowProp([
            [row[0], 'supplier_sku', supplierSkuPrefix + supplierSize]
          ], '80s.updateSupplierData');
        }
        if (supplierDescriptionPrefix) {
          App.ProductBuilder.hot.setDataAtRowProp([
            [row[0], 'supplier_description', supplierDescriptionPrefix + supplierSize]
          ], '80s.updateSupplierData');
        }
      });
    }

    function afterRemoveRow(index, amount) {
      updateHotData();
    }

    function updateHotData() {
      if (App.ProductBuilder.hot) {
        var data = JSON.stringify(App.ProductBuilder.hot.getSourceData());
        $("#form_variants").val(data);
      }
    }

    function requiredValidator(value, callback) {
      callback(value ? true : false)
    }

    //check to see if dropship checkbox is checked
    const ds = document.getElementById('item_dropship')
    const dsi = document.querySelector('.dropship-include-checkbox')
    ds.addEventListener('change',function(){
      if(ds.checked){
        //show dropship include checkbox
        showDropshipIncludeCheckbox();
      }else{
        //uncheck and hide dropship include checkbox
        hideAndUncheckDropshipInclude();
      }
    });

    if(ds.checked){
      showDropshipIncludeCheckbox()
    }

    function showDropshipIncludeCheckbox(){
      dsi.classList.remove('hidden');
    }
    function hideAndUncheckDropshipInclude(){
      const dsicb = dsi.querySelector("input[type='checkbox']")
      dsicb.checked = false;
      dsi.classList.add('hidden');
    }
    

    var variants = $("#form_variants");
    var data = JSON.parse(variants.val());
    var hasSize = variants.data("hasSize");
    var existingSizes = _.map(data, function(v) { return v.size });
    var container = document.getElementById("hot_variants");
    var colHeaders = ["Color", "Size", "Body Style", "Internal SKU", "Supplier Sku", "Supplier Description", "UPC", "Supplier Price", "Price", "Full Price", "Site Price" , "Waist", "Width", "Inseam", "Length", "Weight", "Sleeve Length", "Dropship Exclude", "Ignore Price Adders"];
    var cols = [
      { data: "color", type: "autocomplete" },
      { data: "size", type: "autocomplete", source: hotSizes, strict: true },
      { data: "body_style", type: "autocomplete" },
      { data: "item_code", type: "text", readOnly: true },
      { data: "supplier_sku", type: "text", validator: requiredValidator },
      { data: "supplier_description", type: "text" },
      { data: "upc_code", type: "text" },
      { data: "supplier_price", type: "numeric", format: "0.00", validator: requiredValidator },
      { data: "price", type: "numeric", format: "0.00", validator: requiredValidator },
      { data: "full_price", type: "numeric", format: "0.00", validator: requiredValidator },
      { data: "site_price", type: "numeric", format: "0.00", editor: false},
      { data: "waist", type: "numeric", format: "0.00" },
      { data: "width", type: "numeric", format: "0.00" },
      { data: "inseam", type: "numeric", format: "0.00" },
      { data: "length", type: "numeric", format: "0.00" },
      { data: "weight", type: "numeric", format: "0.00" },
      { data: "sleeve_length", type: "numeric", format: "0.00" },
      { data: "dropship_exclude", type: "checkbox", className: "htCenter" },
      { data: "ignore_price_adders", type: "checkbox", className: "htCenter" }
    ];

    App.ProductBuilder.hot = new Handsontable(container, {
      data: data,
      colHeaders: colHeaders,
      columns: cols,
      afterChange: afterChange,
      afterRemoveRow: updateHotData,
      minSpareRows: hasSize ? 5 : 0,
      allowInsertRow: hasSize,
      allowRemoveRow: hasSize,
      selectionMode: 'multiple',
    });

    App.ProductBuilder.hot.updateSettings({
      contextMenu: {
        items: {
          "row_above": {},
          "row_below": {},
          "remove_row": {}
        }
      },
    });
    // App.ProductBuilder.hot.validateCells();
  }

  function initAltSuppliers() {
    var root = document.getElementById("alt-suppliers");
    if (!root || root.getAttribute("data-alt-ready")) return;
    root.setAttribute("data-alt-ready", "1");

    var chips = root.querySelectorAll(".alt-supplier-btn");
    for (var i = 0; i < chips.length; i++) {
      chips[i].addEventListener("click", function (event) {
        var panelId = this.getAttribute("data-alt-panel");
        var panel = document.getElementById(panelId);
        if (!panel) return;
        if (event && event.preventDefault) event.preventDefault();
        var opening = panel.hasAttribute("hidden");
        var panels = root.querySelectorAll(".alt-supplier-panel");
        for (var p = 0; p < panels.length; p++) {
          panels[p].setAttribute("hidden", "hidden");
          panels[p].classList.remove("is-open");
        }
        var allChips = root.querySelectorAll(".alt-supplier-btn");
        for (var c = 0; c < allChips.length; c++) {
          allChips[c].classList.remove("is-open");
        }
        if (opening) {
          panel.removeAttribute("hidden");
          panel.classList.add("is-open");
          this.classList.add("is-open");
        }
      });
    }

    var descInputs = root.querySelectorAll("input[data-swiftpod-sku]");
    for (var d = 0; d < descInputs.length; d++) {
      bindSwiftpodDescription(descInputs[d]);
    }
  }

  function bindSwiftpodDescription(input) {
    function copySku() {
      var parts = input.value.split("-");
      var skuInput = document.getElementById(input.getAttribute("data-swiftpod-sku"));
      if (skuInput) {
        skuInput.value = parts.length > 1 ? parts[parts.length - 1].replace(/^\s+|\s+$/g, "") : "";
      }
    }

    function warnEl() {
      var el = input.parentNode && input.parentNode.querySelector(".alt-field-warn");
      if (el) return el;
      el = document.createElement("div");
      el.className = "alt-field-warn";
      el.hidden = true;
      if (input.parentNode) input.parentNode.appendChild(el);
      return el;
    }

    function validate() {
      var message = swiftpodDescriptionError(input);
      var warn = warnEl();
      if (message) {
        input.classList.add("is-invalid");
        warn.textContent = message;
        warn.hidden = false;
      } else {
        input.classList.remove("is-invalid");
        warn.textContent = "";
        warn.hidden = true;
      }
    }

    input.addEventListener("input", function () {
      copySku();
      if (input.classList.contains("is-invalid")) validate();
    });
    input.addEventListener("blur", validate);
  }

  function swiftpodDescriptionError(input) {
    var value = (input.value || "").replace(/^\s+|\s+$/g, "");
    if (!value) return null;

    var minParts = parseInt(input.getAttribute("data-swiftpod-min-parts"), 10) || 3;
    var example = input.getAttribute("data-swiftpod-example") || "designName-COLOR-blankSku";
    var parts = value.split("-");
    var i;
    if (parts.length < minParts) {
      return "Needs " + minParts + " '-' segments (" + example + ").";
    }
    for (i = 0; i < parts.length; i++) {
      if (!parts[i].replace(/^\s+|\s+$/g, "")) {
        return "Each '-' segment needs a value (" + example + ").";
      }
    }
    return null;
  }

  return {
    initNew: initNew,
    initEdit: initEdit,
    initPublish: initPublish
  }
})();
